export default "__VITE_ASSET__cdbd1ff7__"